import { useEffect } from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Form, Input, Flex, InputNumber, Button } from "antd";

import StyledModal from "./style";

import {
  cleanPhoneMask,
  selectValue,
  setPhoneMask,
} from "../../../../../../../../../utils/helper/general";

import { faTrash, faUserPlus } from "@fortawesome/free-solid-svg-icons";

const ModalClientPersonalInfo = ({
  clientData,
  loading,
  onCancel,
  onFinish,
  open,
  viewType,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open || !form) return;

    form.resetFields();

    if (clientData) {
      form.setFieldsValue({
        ...clientData,
        ...clientData.valueMap?.guideInitialData,
        oldEmail: clientData.email,
      });
    }
  }, [open]);

  const onClickDeleteSpouse = () => {
    onFinish({
      spouseFirstName: "",
      spouseLastName: "",
      spouseEmail: "",
      spousePhoneNumber: "",
      spousePhoneAlt: "",
      spouseBirthYear: "",
      spouseRetirementAge: "",
      oldEmail: clientData.email,
    });
  };

  const ContentPersonal = () => (
    <>
      <Flex gap={16}>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
      </Flex>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            type: "email",
          },
        ]}
      >
        <Input size="large" />
      </Form.Item>
      <Flex gap={17}>
        <Form.Item
          label="Phone"
          name="phoneNumber"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber
            controls={false}
            formatter={setPhoneMask}
            onClick={selectValue}
            parser={cleanPhoneMask}
            size="large"
          />
        </Form.Item>
        <Form.Item label="Phone alt" name="phoneAlt">
          <InputNumber
            controls={false}
            formatter={setPhoneMask}
            onClick={selectValue}
            parser={cleanPhoneMask}
            size="large"
          />
        </Form.Item>
      </Flex>
      <Flex gap={16}>
        <Form.Item
          label="Birth Year"
          name="birthYear"
          rules={[
            {
              max: dayjs().format("YYYY") - 5,
              min: 1940,
              required: true,
              type: "number",
            },
          ]}
          style={{ width: "100%" }}
        >
          <InputNumber
            id="yearBornInput"
            inputMode="numeric"
            onClick={selectValue}
            pattern="[0-9]*"
            placeholder="YYYY"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>
        <Form.Item
          label="Retirement Age"
          name="retirementAge"
          rules={[
            {
              type: "number",
              min: 20,
              max: 100,
            },
          ]}
          style={{ width: "100%" }}
        >
          <InputNumber
            inputMode="numeric"
            onClick={selectValue}
            pattern="[0-9]*"
            placeholder="YYYY"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Flex>
    </>
  );

  const ContentSpouse = () => (
    <>
      <Flex gap={16}>
        <Form.Item
          label="First Name"
          name="spouseFirstName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="spouseLastName"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
      </Flex>
      <Form.Item
        label="Email"
        name="spouseEmail"
        rules={[
          {
            required: true,
            type: "email",
          },
        ]}
      >
        <Input size="large" />
      </Form.Item>
      <Flex gap={17}>
        <Form.Item
          label="Phone"
          name="spousePhoneNumber"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber
            controls={false}
            formatter={setPhoneMask}
            onClick={selectValue}
            parser={cleanPhoneMask}
            size="large"
          />
        </Form.Item>
        <Form.Item label="Phone alt" name="spousePhoneAlt">
          <InputNumber
            controls={false}
            formatter={setPhoneMask}
            onClick={selectValue}
            parser={cleanPhoneMask}
            size="large"
          />
        </Form.Item>
      </Flex>
      <Flex gap={16}>
        <Form.Item
          label="Birth Year"
          name="spouseBirthYear"
          rules={[
            {
              max: dayjs().format("YYYY") - 5,
              min: 1940,
              required: true,
              type: "number",
            },
          ]}
          style={{ width: "100%" }}
        >
          <InputNumber
            inputMode="numeric"
            onClick={selectValue}
            pattern="[0-9]*"
            placeholder="YYYY"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>
        <Form.Item
          label="Retirement Age"
          name="spouseRetirementAge"
          rules={[
            {
              type: "number",
              min: 20,
              max: 100,
            },
          ]}
          style={{ width: "100%" }}
        >
          <InputNumber
            inputMode="numeric"
            onClick={selectValue}
            pattern="[0-9]*"
            placeholder="YYYY"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Flex>
    </>
  );

  const ContentDependents = () => (
    <div className="container-dependents">
      <Form.List name="dependents" initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <Flex gap={16} vertical>
            {fields.map(field => (
              <Flex
                align="start"
                gap={16}
                justify="space-between"
                key={field.key}
              >
                <Form.Item label="First Name" name={[field.name, "firstName"]}>
                  <Input />
                </Form.Item>
                <Form.Item label="Last Name" name={[field.name, "lastName"]}>
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Birth Year"
                  name={[field.name, "birthYear"]}
                  rules={[
                    {
                      type: "number",
                      min: 1940,
                      max: dayjs().format("YYYY") - 5,
                    },
                  ]}
                >
                  <InputNumber onClick={selectValue} placeholder="YYYY" />
                </Form.Item>
                <Button
                  className="button-remove-dependent"
                  icon={<FontAwesomeIcon icon={faTrash} />}
                  onClick={() => remove(field.name)}
                  shape="circle"
                />
              </Flex>
            ))}
            <div>
              <Button
                icon={<FontAwesomeIcon icon={faUserPlus} />}
                onClick={() => add()}
                shape="round"
              >
                Add Dependent
              </Button>
            </div>
          </Flex>
        )}
      </Form.List>
    </div>
  );

  return (
    <StyledModal
      closeIcon={false}
      footer={
        <Flex justify="space-between">
          <Button onClick={onCancel} shape="round">
            Cancel
          </Button>

          <Flex gap={16}>
            {viewType === "spouse" && (
              <Button
                icon={<FontAwesomeIcon icon={faTrash} />}
                onClick={onClickDeleteSpouse}
                shape="round"
              >
                Delete Spouse
              </Button>
            )}
            <Button
              disabled={loading}
              form="formClientPersonalInfo"
              htmlType="submit"
              shape="round"
              type="primary"
            >
              Update
            </Button>
          </Flex>
        </Flex>
      }
      onCancel={onCancel}
      open={open}
      title={`Edit ${viewType} Info`}
      width={647}
    >
      <Form
        id="formClientPersonalInfo"
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        {viewType === "personal" && <ContentPersonal />}
        {viewType === "spouse" && <ContentSpouse />}
        {viewType === "dependents" && <ContentDependents />}

        <Form.Item hidden name="oldEmail" />
      </Form>
    </StyledModal>
  );
};

export default ModalClientPersonalInfo;
